import React from 'react';
import { CreditCard } from 'lucide-react';
import { motion } from 'framer-motion';

export const EmptyTerminalsState: React.FC = () => {
  return (
    <div className="p-12 text-center">
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ type: "spring", duration: 0.5 }}
        className="w-20 h-20 mx-auto mb-4 bg-gradient-to-br from-blue-100 to-blue-200 rounded-3xl flex items-center justify-center"
      >
        <CreditCard className="h-10 w-10 text-blue-600" />
      </motion.div>
      <h3 className="text-[18px] font-bold text-gray-900 mb-2">אין מסופים</h3>
      <p className="text-[14px] text-gray-600 max-w-sm mx-auto">
        המסופים שלך יופיעו כאן לאחר השלמת תהליך ההזמנה
      </p>
    </div>
  );
};
